// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
.index-module__actionAllDevice__RPnXU {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.index-module__actionGroup__rzVeN {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.index-module__actionButton__jcsFx {
  width: 100%;
  font-size: 12px;
}
.index-module__head-container__IxeL_ {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__left-section__PEQ6z {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  width: 100%;
}
.index-module__right-section__WGWSm {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  width: 100%;
}
.index-module__filters-container__rYyOh {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
}
.index-module__formFooter__Ndf5t {
  display: flex;
  justify-content: flex-end;
  gap: 30px;
  margin-top: 20px;
  margin-right: 30px;
}
.index-module__button-m01__vxmdA {
  font-size: 14px;
  padding: 8px 16px;
}
.index-module__form-itemFloatR20__jVUMZ {
  margin-bottom: 0;
}
.index-module__modal__description__rPwG9 {
  font-weight: bolder;
  color: var(--app-primary-color) !important;
  cursor: pointer;
}
.index-module__extra-container__g6UQM {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
}
.index-module__extra-container__g6UQM .index-module__order-1__eZNwJ {
  order: 1;
}
.index-module__order-2__ovVSx {
  order: 0;
}
.index-module__search-filter-container__Pbya_ {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
/* Mobile styles */
@media (max-width: 1024px) {
  .index-module__left-section__PEQ6z {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .index-module__right-section__WGWSm {
    flex-direction: column;
    align-items: flex-end;
    gap: 0.5rem;
  }
}
@media (max-width: 480px) {
  .index-module__left-section__PEQ6z,
  .index-module__right-section__WGWSm {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdvanceBookingRequest/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA,kBAAkB;AAClB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;EACb;AACF;AACA;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;AACF","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n.actionAllDevice {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n.actionGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n.actionButton {\n  width: 100%;\n  font-size: 12px;\n}\n.head-container {\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.left-section {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n}\n.right-section {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n}\n.filters-container {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 20px;\n}\n.formFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 30px;\n  margin-top: 20px;\n  margin-right: 30px;\n}\n.button-m01 {\n  font-size: 14px;\n  padding: 8px 16px;\n}\n.form-itemFloatR20 {\n  margin-bottom: 0;\n}\n.modal__description {\n  font-weight: bolder;\n  color: var(--app-primary-color) !important;\n  cursor: pointer;\n}\n.extra-container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 20px;\n}\n.extra-container .order-1 {\n  order: 1;\n}\n.order-2 {\n  order: 0;\n}\n.search-filter-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n/* Mobile styles */\n@media (max-width: 1024px) {\n  .left-section {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  .right-section {\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.5rem;\n  }\n}\n@media (max-width: 480px) {\n  .left-section,\n  .right-section {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionAllDevice": `index-module__actionAllDevice__RPnXU`,
	"actionGroup": `index-module__actionGroup__rzVeN`,
	"actionButton": `index-module__actionButton__jcsFx`,
	"head-container": `index-module__head-container__IxeL_`,
	"left-section": `index-module__left-section__PEQ6z`,
	"right-section": `index-module__right-section__WGWSm`,
	"filters-container": `index-module__filters-container__rYyOh`,
	"formFooter": `index-module__formFooter__Ndf5t`,
	"button-m01": `index-module__button-m01__vxmdA`,
	"form-itemFloatR20": `index-module__form-itemFloatR20__jVUMZ`,
	"modal__description": `index-module__modal__description__rPwG9`,
	"extra-container": `index-module__extra-container__g6UQM`,
	"order-1": `index-module__order-1__eZNwJ`,
	"order-2": `index-module__order-2__ovVSx`,
	"search-filter-container": `index-module__search-filter-container__Pbya_`
};
export default ___CSS_LOADER_EXPORT___;
